export const getUserFullName = (
  user: { name: string | null; surname: string | null } | null | undefined
) => {
  if (!user) return "";
  const name = user.name ?? "";
  const surname = user.surname ?? "";
  return [name, surname].filter(Boolean).join(" ");
};
